module.exports = "files/thank_you.png";